import http from "../http-common";

class EmailService {
  // Test email configuration (admin only)
  testEmailConfig() {
    return http.post("/email/test-config");
  }

  // Send test email (admin only)
  sendTestEmail(data) {
    return http.post("/email/test", data);
  }

  // Send welcome email to user
  sendWelcomeEmail(userId) {
    return http.post(`/email/welcome/${userId}`);
  }

  // Send password reset email
  sendPasswordResetEmail(data) {
    return http.post("/email/password-reset", data);
  }

  // Send expense notification email
  sendExpenseNotificationEmail(data) {
    return http.post("/email/expense-notification", data);
  }

  // Send family invitation email
  sendFamilyInvitationEmail(data) {
    return http.post("/email/family-invitation", data);
  }

  // Send weekly expense summary
  sendWeeklyExpenseSummary(userId, familyId) {
    return http.get(`/email/weekly-summary/${userId}/${familyId}`);
  }

  // Get email statistics (admin only)
  getEmailStats() {
    return http.get("/email/stats");
  }
}

export default new EmailService();
